import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const visuallyHidden = {
	position: 'absolute',
	width: '1px',
	height: '1px',
	padding: 0,
	margin: '-1px',
	overflow: 'hidden',
	clip: 'rect(0, 0, 0, 0)',
	whiteSpace: 'nowrap',
	border: 0,
};

const getToastMessage = (content) => {
	if (typeof content === 'string' || typeof content === 'number') {
		return String(content);
	}
	return '';
};

const announce = (setter, message) => {
	setter('');
	window.requestAnimationFrame(() => setter(message));
};

export default function StatusAnnouncer() {
	const [politeMessage, setPoliteMessage] = useState('');
	const [assertiveMessage, setAssertiveMessage] = useState('');

	useEffect(() => {
		return toast.onChange((item) => {
			if (item.status !== 'added' || item.isLoading) {
				return;
			}

			const message = getToastMessage(item.content);
			if (!message) {
				return;
			}

			if (item.type === 'error') {
				announce(setAssertiveMessage, message);
				return;
			}

			announce(setPoliteMessage, message);
		});
	}, []);

	return (
		<>
			<div role="status" style={visuallyHidden}>
				{politeMessage}
			</div>
			<div role="alert" style={visuallyHidden}>
				{assertiveMessage}
			</div>
		</>
	);
}
